import { checkIsMobileApp } from 'utilities';

export const IS_IN_WEBVIEW =
  checkIsMobileApp(window?.location?.search) || !!window?.RedshelfWebView;

export const COOKIE_POLICY_URL =
  'https://support.vitalsource.com/hc/en-us/articles/360003928273-VitalSource-Technologies-LLC-Cookie';
